import { DEFAULT_LOCATION_OBJ } from '@/utils/constants'
import {createSlice } from '@reduxjs/toolkit'

const defaultLocationObj = DEFAULT_LOCATION_OBJ
const cityInitialState = {
  currentCityObj: defaultLocationObj?.city,
  allCitiesList: [],
  isCityServicable: true,
}

const citySlice = createSlice({
  name: 'cityDataReducer',
  initialState: cityInitialState,
  reducers: {
    updateCityData: (state, action) => {
      state.currentCityObj = action.payload.currentCityObj
      state.allCitiesList = action.payload.allCitiesList
      state.isCityServicable = action.payload.isCityServicable
    },
  },
})

export const {updateCityData } = citySlice.actions
export default citySlice.reducer
